import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseListResponse, BaseModel } from '../models/BaseModel';
import {  ProjectResponse } from '../models/projects/projectResponse';
import {
  ExistingApplicationInfo
} from "../models/grantApplication/grantApplicationResponse";

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private apiUrl = environment.apiConfig.uri+ '/api/project';

  constructor(private http: HttpClient) { }

  getProjectList(page : number, limit: number, sortColumn : string): Observable<BaseModel<BaseListResponse<ProjectResponse>>> {
    return this.http.get<BaseModel<BaseListResponse<ProjectResponse>>>(`${this.apiUrl}/query/${page}/${limit}?sort=${sortColumn}`);
  }

  getProject(id : string): Observable<BaseModel<ProjectResponse>> {
    return this.http.get<BaseModel<ProjectResponse>>(`${this.apiUrl}/getinfo/${id}`);
  }

  ExistingApplication(queryParams: { [key: string]: any }): Observable<BaseModel<ExistingApplicationInfo>> {
    const queryString = new URLSearchParams(queryParams).toString();
    return this.http.get<BaseModel<ExistingApplicationInfo>>(`${this.apiUrl}/getDraftApplicationIfExists?${queryString}`);
  }

  ExistingNoDraftApplication(queryParams: { [key: string]: any }): Observable<BaseModel<ExistingApplicationInfo>> {
    const queryString = new URLSearchParams(queryParams).toString();
    return this.http.get<BaseModel<ExistingApplicationInfo>>(`${this.apiUrl}/getApplicationIfExists?${queryString}`);
  }


}
